import { sidebarConstants } from "@_constants/sidebar.constants";
import caseStates from "@_configs/caseStates.config";

const initialState = {
  status: "DASHBOARD",
  casesAsc:
    localStorage.getItem("casesAsc") &&
    JSON.parse(localStorage.getItem("casesAsc"))
      ? true
      : false,
  standbyAsc:
    (localStorage.getItem("standbyAsc") &&
      JSON.parse(localStorage.getItem("standbyAsc"))) ||
    false,
  paidAsc:
    (localStorage.getItem("paidAsc") &&
      JSON.parse(localStorage.getItem("paidAsc"))) ||
    false,
  activeAsc:
    (localStorage.getItem("activeAsc") &&
      JSON.parse(localStorage.getItem("activeAsc"))) ||
    false,
  cancelledAsc:
    (localStorage.getItem("cancelledAsc") &&
      JSON.parse(localStorage.getItem("cancelledAsc"))) ||
    false,
  valid_licenseAsc:
    (localStorage.getItem("valid_licenseAsc") &&
      JSON.parse(localStorage.getItem("valid_licenseAsc"))) ||
    false,
  payment_processingAsc:
    (localStorage.getItem("payment_processingAsc") &&
      JSON.parse(localStorage.getItem("payment_processingAsc"))) ||
    false,
  optionalFilter: null,
  numbers: {},
  selections: {},
  hideCaseList: false,
};
Object.keys(caseStates).map((state, i) => {
  initialState.numbers[state] = "--";
  initialState.selections[state] = null;
  return initialState;
});

export function sidebarReducer(state = initialState, action) {
  switch (action.type) {
    case sidebarConstants.UPDATE_STATUS:
      state = {
        ...state,
        status: action.status,
        optionalFilter: action.optionalFilter,
      };
      break;

    case sidebarConstants.INIT_NUMBERS:
      const numbers = Object.assign(state.numbers, action.numbers);
      state = { ...state, numbers: numbers };
      break;

    case sidebarConstants.UPDATE_SELECTIONS:
      state = {
        ...state,
        selections: { ...state.selections, [state.status]: action.id },
      };
      break;
    case sidebarConstants.RESET_FILTER:
      state = {
        ...state,
        optionalFilter: null,
      };
      break;
    case sidebarConstants.SORT_CASES:
      state = {
        ...state,
        [action.caseType]: action.ascending,
      };
      break;
    default:
      break;
  }

  return state;
}
